class Unleash {
    feature() {
        return _.get(window.slurp, 'unleash');
    }

    hasFeature(feature) {
        return this.feature()[feature];
    }
}

const UnleashInstance = new Unleash();

export default UnleashInstance;



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/unleash.js